import { IonAvatar, IonButton, IonButtons, IonCard, IonCardContent, IonChip, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonImg, IonItem, IonLabel, IonMenuButton, IonPage, IonRow, IonSearchbar, IonSkeletonText, IonTitle, IonToolbar, useIonAlert, useIonRouter, useIonToast, useIonViewDidEnter } from '@ionic/react';
import { checkmarkCircleOutline, chevronBackOutline, hourglassOutline, manOutline, peopleOutline } from 'ionicons/icons';
import React, { useRef, useState } from 'react';
import InitialsAvatar from 'react-initials-avatar';
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';
import { useAppContext } from '../AppProvider';

const PartnerCreate: React.FC = () => {
    const [loading, setLoading] = useState<boolean>(true);
    const [results, setResults] = useState<any[]>([]);

    const { authKey, authenticateMember, settings, setShowLoader, SWFullHorizLogo, SWTextDarkLogo } = useAppContext();
    
    const [showAlert] = useIonAlert();
    const [showToast] = useIonToast();
    const query = useRef<any>(); 
    const router = useIonRouter();

    //
    // Authenticate Member
    //
    useIonViewDidEnter(() => { 
        const authenticate = async () => {
            const authenticated = await authenticateMember();   
            if(!authenticated || authenticated.mt == '') router.push('/login', 'forward');
            else {
                setShowLoader(false);
            }
        };
        authenticate();
    }); 

    const getPartnerSearch = async () => {
        const q = query.current.value;
        try {
            const formData = new FormData();
            formData.append('mt', authKey.mt);
            formData.append('q', q);
            const response = await fetch('https://api.besolowise.com/members/search/', {
                method: 'POST',
                credentials: 'include',
                body: formData
            });

            if(response.ok) {   
                const json = await response.json();  
                setResults(json);
                setTimeout(() => setLoading(false), 1500);
            } else {
                showToast({
                    message: 'Response Error. Refresh this page to try again.',
                    duration: 3000,
                    color: 'danger',
                    position: 'middle'
                });
            }
        } catch(error) {
            showToast({
                message: 'Connection Error: ' + error + '. Refresh this page to try again.',
                duration: 3000,
                color: 'danger',
                position: 'middle'
            });
        } 
    };

    const addPartner = async (pt: string) => {
        showAlert({
            header: 'Confirm!',
            message: 'Are you sure you want to CONNECT with this Partner?',
            buttons: [
                { text: 'Cancel',
                  role: 'cancel', 
                  cssClass: 'alert-button-cancel',
                },
                {
                    text: 'Connect',
                    role: 'confirm',
                    cssClass: 'alert-button-confirm',
                    handler: async () => {
                        try {
                            const formData = new FormData();
                            formData.append('token', pt);
                            formData.append('mt', authKey.mt);
                            const apiURI = 'https://api.besolowise.com/partners/insert/';
                            const response = await fetch(apiURI, {
                                method: 'POST',
                                credentials: 'include',
                                body: formData
                            });
                            
                            if(response.ok) {
                                const obj = await response.json(); 
                                console.log(obj);
                                if(obj.success) router.push('/account/partners', 'back');
                                else {
                                    showToast({
                                        message: obj.message,
                                        duration: 3000,
                                        color: 'danger',
                                    });
                                }
                            } else {
                                showToast({
                                    message: 'Response Error',
                                    duration: 2000,
                                    color: 'danger',
                                });
                            }
                        } catch(error) {
                            showToast({
                                message: 'Connection Error: ' + error,
                                duration: 2000,
                                color: 'danger',
                            });
                        }  
                    }
                }
            ]
        })
    };

    const statusChip = (s: any, t: string) => {
        switch(s) {
            case false: return <IonButton slot='end' color={'secondary'} onClick={() => addPartner(t)} shape='round'>Connect</IonButton>;
            case '0': return <IonChip slot='end' color={'medium'}><IonIcon icon={hourglassOutline} className='ion-margin'></IonIcon></IonChip>
            case '1': return <IonChip slot='end' color={'medium'}><IonIcon icon={hourglassOutline} className='ion-margin'></IonIcon></IonChip>
            case '2': return <IonChip slot='end' color={'success'}><IonIcon icon={checkmarkCircleOutline} className='ion-margin'></IonIcon></IonChip>
            default:  return <IonChip slot='end' color={'warning'}>Unknown</IonChip>
        }
    }

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot='start'>
                        <IonButton color={'tertiary'} routerDirection='back' routerLink='/account/partners'>Partners</IonButton>
                    </IonButtons>
                    <IonTitle><IonImg className='headerTextLogo' src={settings.theme == '1' ? SWTextDarkLogo : SWFullHorizLogo}></IonImg></IonTitle>
                    <IonButtons slot='end'>
                        <IonMenuButton color={'tertiary'} />
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding account-content-bg" id='Partners'>
                <IonGrid>
                    <IonRow>
                        <IonCol size='12'>
                            <h1><IonIcon color={'secondary'} icon={manOutline}></IonIcon> New Partners<br /><span>Connect with other SoloWise Members </span></h1>
                        </IonCol>
                    </IonRow>
                </IonGrid>

                <IonSearchbar color={'light'} showClearButton="focus" onIonChange={getPartnerSearch} placeholder="Search by last name" ref={query}></IonSearchbar>
                <div>
                    {results != null && results.length > 0
                        ? (results.map((member, index) => (                    
                            <IonCard key={index}>
                                <IonCardContent className='ion-no-padding'>
                                    <IonItem lines='none'>
                                        {loading 
                                            ? (<IonAvatar slot='start'><IonSkeletonText animated={true}></IonSkeletonText></IonAvatar>)
                                            : (member.memberPhoto1Url == ''
                                                ? (<InitialsAvatar className='initials-avatar' name={`${member.memberFirstName} ${member.memberLastName}`} />)  
                                                : (<IonAvatar slot='start'><IonImg src={member.memberPhoto1Url} /></IonAvatar>))
                                        } 
                                        <IonLabel>
                                            {loading 
                                                ? (<h2><IonSkeletonText animated={true} style={{ width: '50%' }}></IonSkeletonText></h2>)
                                                : (<h2>{member.memberFirstName} {member.memberLastName}</h2>)
                                            }
                                        </IonLabel>                                        
                                        {loading ? '' : statusChip(member.partnerStatus, member.memberToken)}
                                    </IonItem>
                                </IonCardContent>
                            </IonCard>
                        )))
                        : (!loading &&
                                (query.current.value == ''
                                        ? (<p className='ion-text-center'>Search by last name above.</p>)
                                        : (<p className='ion-text-center'>No results for "{query.current.value}".</p>)
                                )
                            )
                    }    
                </div>
            </IonContent>
        </IonPage>
    );
};

export default PartnerCreate;